import { render, staticRenderFns } from "./platbody-add-or-update.vue?vue&type=template&id=fb4e2f38&"
import script from "./platbody-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platbody-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports